import { InputText } from 'primereact/inputtext';
import { useRef, useEffect } from 'react';
import { Skeleton } from 'primereact/skeleton';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';

export const FormIrrigacao = ({ isEditing, isLoading, visible, setVisible, values, setFieldValue, errors, touched, setFieldTouched }) => {
    const toast = useRef(null);

    useEffect(() => {
        if (values.naoNecessarias) {
            setFieldValue("irrigacao.sistema", '');
            setFieldValue("irrigacao.origem", '');
            setFieldTouched("irrigacao.sistema", true);
            setFieldTouched("irrigacao.origem", true);

            setTimeout(() => {
                setFieldValue("irrigacao.naoNecessarias", true);
            }, 0);
        }
    }, [values.naoNecessarias, setFieldValue, setFieldTouched]);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFieldValue(`irrigacao.${name}`, checked);
    };

    const isFormFieldValid = (name) => {
        const isValid = !!(touched?.[name] && errors?.[name]);
        return isValid;
    };

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <div className="p-formgrid p-grid p-fluid p-mx-0">
                    <div className="p-col-12">
                        <div className="p-d-flex p-flex-wrap p-ai-center p-jc-start">
                            <div className="p-field p-d-flex p-ai-center p-mr-3 p-mb-3 p-col-1">
                                <label htmlFor="naoNecessarias" className={classNames('p-mr-2', { 'p-error': isFormFieldValid('naoNecessarias') })}>
                                    Não são necessárias
                                </label>
                                <Checkbox
                                    id="naoNecessarias"
                                    name="naoNecessarias"
                                    checked={values.naoNecessarias}
                                    onChange={handleCheckboxChange}
                                />
                            </div>
                            <div className="p-field p-d-flex p-flex-column p-mr-3 p-mb-3 p-col">
                                <label
                                    htmlFor="sistema"
                                    className={classNames({ 'p-error': isFormFieldValid('sistema') })}
                                >
                                    Sistema de Irrigação
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="sistema"
                                            name="sistema"
                                            className={classNames({ 'p-invalid': isFormFieldValid('sistema') })}
                                            value={values.sistema}
                                            onChange={(e) => {
                                                setFieldValue("irrigacao.sistema", e.target.value);
                                                setFieldTouched("irrigacao.sistema", true);
                                            }}
                                            onBlur={() => setFieldTouched("irrigacao.sistema", true)}
                                            disabled={isLoading || values.naoNecessarias}
                                            placeholder='Descreva o Sistema de Irrigação'
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                            </div>
                            {errors?.sistema && touched?.sistema &&
                                <ErrorValidationMessage message={errors.sistema} />
                            }
                            <div className="p-field p-d-flex p-flex-column p-mr-3 p-mb-3 p-col">
                                <label
                                    htmlFor="origem"
                                    className={classNames({ 'p-error': isFormFieldValid('origem') })}
                                >
                                    Origem da Água
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="origem"
                                            name="origem"
                                            className={classNames({ 'p-invalid': isFormFieldValid('origem') })}
                                            value={values.origem}
                                            onChange={(e) => {
                                                setFieldValue("irrigacao.origem", e.target.value);
                                                setFieldTouched("irrigacao.origem", true);
                                            }}
                                            onBlur={() => setFieldTouched("irrigacao.origem", true)}
                                            disabled={isLoading || values.naoNecessarias}
                                            placeholder='Descreva a Origem da Água'
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                            </div>
                            {errors?.origem && touched?.origem &&
                                <ErrorValidationMessage message={errors.origem} />
                            }
                        </div>
                        {!values.naoNecessarias && !values.sistema && !values.origem && (
                            <div className="p-error">Pelo menos um campo deve ser preenchido.</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}